<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  created() {
    this.axios.interceptors.response.use(
      response => {
        return Promise.resolve(response);
      },
      error => {
        if (error.response) {
          if (error.response.status === 500) {
            this.$store.dispatch("ui/makeToast", {
              icon: "error",
              title: "Error en el servidor"
            });
          }
          if (
            error.response.status === 401 &&
            error.response.data.type !== "login"
          ) {
            this.$store.dispatch("logout");
            return Promise.reject(error);
          } else {
            return Promise.reject(error);
          }
        } else {
          this.$store.dispatch("ui/makeToast", {
            icon: "error",
            title: "Parece que hay un error al conectar con el servidor."
          });
        }
      }
    );
  }
};
</script>
